import { pruneStaleBullionLobbyRows } from "./bullionLobbyStalePrune";
import type { BullionLobbyUserActiveGame } from "./types";

/** Shared with Bullion lobby + match landing so deep links can paint from the last lobby fetch. */
export const BULLION_LOBBY_EVENTS_CACHE_KEY = "c8_bullion_lobby_events_v1";

export function readCachedBullionLobbyEvents(): unknown[] | null {
    if (typeof sessionStorage === "undefined") return null;
    try {
        const raw = sessionStorage.getItem(BULLION_LOBBY_EVENTS_CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as { events?: unknown };
        const ev = parsed?.events;
        if (!Array.isArray(ev) || ev.length === 0) return null;
        return ev;
    } catch {
        return null;
    }
}

export function writeCachedBullionLobbyEvents(
    events: unknown[],
    opts?: { activeByMatch?: Record<string, BullionLobbyUserActiveGame[]> }
) {
    const pruned = pruneStaleBullionLobbyRows(events, opts?.activeByMatch);
    try {
        sessionStorage.setItem(BULLION_LOBBY_EVENTS_CACHE_KEY, JSON.stringify({ events: pruned }));
    } catch {
        // ignore quota / private mode
    }
}
